import api from '@edu-fe/api'

export default {
  name: 'schedule',
  namespaced: true,
  state () {
    return {
      data: {}
    }
  },
  mutations: {
    setData (state, data) {
      state.data = data
    },
    setFoldSection: (state, section) => {
      state.data.chapterList.forEach(item => {
        if (item.id === section.id) {
          item.isSpread = !item.isSpread
        }
      })
    }
  },
  actions: {
    getData ({ commit }, { courseId }) {
      return api.schedule.getData({
        courseId,
        position: 1
      }).then(res => {
        const data = res.data
        data.chapterList.forEach(item => (item.isSpread = true))
        commit('setData', data)
        return data
      }).catch(err => console.error(err))
    }
  }
}
